export class GetPersonalCreditReport {
  static readonly type = '[CreditReport] Get';

  constructor(public borrowerId: number) {}

}
